/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
class ActionResultClass {
    constructor() {
    }

    ok(r) {
        return {status : "OK", result : r}
    }

    fail(e) {
        return {status : "FAIL", error : e}
    }

    make(actionType,handler) {
        return {
            success : (result) => {handler({action  : actionType, result : this.ok(result)});},
            failure : (result) => {handler({action  : actionType, result : this.fail(result)});}
        }
    }
}

const ActionResult = new ActionResultClass();
export default ActionResult;




// WEBPACK FOOTER //
// ./src/app/stores/ActionResult.js